<template>
  <div class="contract" id="pdfDomContainer">
		<div class="ql-container ql-snow">
			<div class="ql-editor">
				<div class="contract_body" v-html="content"></div>
			</div>
		</div>
	</div>
</template>
<script>
/**
	拼接富文本内容
*/
import request from "@/utils/request";
import html2Canvas from "html2canvas";

const templateContractKeyMap = {
	companyName: 'partyA',
	userName: 'partyB',
	name: 'name',
	number: 'number',
	idCard: 'idCard',
	pickTime: 'pickTime',
	pickAddress: 'pickAddress',
	returnTime: 'returnTime',
	returnAddress: 'returnAddress',
	cardGroup: 'cardGroup',
	cardNumber: 'cardNumber',
	orderId: 'orderId',
	cardDeposit: 'cardDeposit',
	illegalDeposit: 'illegalDeposit',
	// companyImage: 'imageA',
	// userImage: 'imageB'
};

const isNeedSignMap = {
	companyImage: 'imageA',
	userImage: 'imageB'
}
let formData = {};

const orderType = {
	same: '00',
	pick: '01',
	return: '02',
}
const chargeStatusMap = {
	0: "未支付",
	1: "线上已支付",
	2: "退款中",
	3: "已退款",
	4: "已取消",
	5: "有效",
	6: "无效",
	7: "支付中",
	8: "待退款",
	9: "支付失败",
	10: "退款失败",
}
function padLeftZero(str) {
	return ("00" + str).substr(str.length);
}

function timeTransform(str) {
var timezone = 8; //目标时区时间，东八区
var offset_GMT = new Date(str).getTimezoneOffset(); // 本地时间和格林威治的时间差，单位为分钟
var nowDate = new Date(str).getTime(); // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
var targetDate = new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000);
console.log("东8区现在是：" + targetDate);
return targetDate;
}
// 时间格式化
function formatDate(date, fmt) {
	// console.log('formatDate', date);
	// yyyy-MM-dd hh:mm
	let self = this;
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(
			RegExp.$1,
			(date.getFullYear() + "").substr(4 - RegExp.$1.length)
		);
	}
	let o = {
		"M+": date.getMonth() + 1,
		"d+": date.getDate(),
		"h+": date.getHours(),
		"m+": date.getMinutes(),
		"s+": date.getSeconds(),
	};
	for (let k in o) {
		if (new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + "";
			fmt = fmt.replace(
				RegExp.$1,
				RegExp.$1.length === 1 ? str : padLeftZero(str)
			);
		}
	}
	return fmt;
}

function _isMobile() {
	let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	return flag;
}

export default {
	props: {
		order_id: {
      type: String,
      default: '',
    },
		company_id: {
      type: String,
      default: '',
    },
		// 需要最终合同的图片
		is_need_contract_image: {
      type: Boolean,
      default: false,
    },
		quality: {
			type: Number,
			default: 0.3,
		},
		// 需要签名图片
		is_need_sign: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			content: '',
			// content: htmlTemplateModal,
			basicObject: { ...templateContractKeyMap },
			extraObject: { ...isNeedSignMap },
		};
	},

	watch: {
		is_need_sign(nV, oV) {
			const that = this;
			if (nV !== oV && !oV) {
				that.getSignatureAll()
					.then((flag) => {
						if (!flag) {
							return;
						}
						console.log('watch 触发templateData');
						// that.$emit('templateData', that.content);
					});
			}
		},
		is_need_contract_image() {
			this.generate();
		},
	},
	created() {
		console.log('html2Canvas quality', this.quality)
		this.loading = this.$loading({
			lock: true,
			text: "Loading",
			spinner: "el-icon-loading",
			background: "rgba(0, 0, 0, 0.7)"
		});
		this.getCompanyTemplate();
		this.generateLock = false; // 防止方法generate在调用的时候被重新调用
	},
	methods: {
		// 压缩函数
		compress(file) {
			let reader = new FileReader();
			return new Promise((resolve, reject) => {
				reader.onload = e => {
					let data = e.target.result;
					let img = new Image();
					img.src = data;
					img.onload = () => {
						// canvas画图
						const canvas = document.createElement("canvas");
						const context = canvas.getContext("2d");
						const canvasWidth = 750;
						const canvasHeight = (canvasWidth * img.height) / img.width;
						const qualityArgument = 0.6;
						canvas.width = canvasWidth;
						canvas.height = canvasHeight;
						context.clearRect(0, 0, canvasWidth, canvasHeight);
						context.drawImage(img, 0, 0, canvasWidth, canvasHeight);
						resolve(
							this.base64ToFile(
								canvas.toDataURL(file.type, qualityArgument),
								file.name
							)
						);
					};
				};
				reader.readAsDataURL(file);
			});
		},
		// 生成合同图片
    generate() {
			const that = this;
			if (this.isSetComplete() && !this.generateLock) {
				this.generateLock = true;
				this.$nextTick(() => {
					html2Canvas(document.querySelector("#pdfDomContainer"), {
						allowTaint: false, //图片跨域问题解决 老规矩allowTaint、useCORS
						useCORS: true,
					}).then(function(canvas) {
						const { width, height } = canvas;
						const base64Image = canvas.toDataURL("image/jpeg", 0.1);
						that.generateLock = false;
						that.$emit('imageData', {
							src: base64Image,
							width,
							height,
						});
					});
				})
			} else {
				console.log('this.generateLock 正在执行')
			}
    },
		// 获取模板
		getCompanyTemplate() {
      let that = this;
			const { company_id, order_id } = this;
      if (!that.company_id) return;
      request({
        url: '/Api/other/getCompanyTemplate',
        method: 'POST',
        data: {
          company_id,
        },
      })
        .then((res) => {
					that.content = res.data.content;
					// that.content = htmlTemplateModal;
					that.setInfoToContract({
						orderId: that.order_id,
					})
					that.get_simple_order();
					that.get_customer_details_order();
					that.contract_info();
					if (that.is_need_sign) {
						that.getSignatureAll();
					}
        })
        .catch((err) => {
          console.log(err);
          that.$message({
            type: 'error',
            message: err.msg || '',
          });
        });
    },
    // 获取电子合同信息 订单id 公司id 或 token 二选一
    contract_info() {
      let that = this;
      if (!that.company_id && !that.driver_token) return;
      request({
        url: '/Api/other/contract_info',
        method: 'POST',
        data: {
          order_id: that.order_id,
          company_id: that.company_id,
          driver_token: that.driver_token,
        },
      })
        .then((res) => {
					if (res.code == 0) {
						const { company_name, cust_full_name } = res.data;
						that.companyName = company_name;
						that.setInfoToContract({
							companyName: company_name,
							userName: cust_full_name,
							name: cust_full_name,
						});
					}
        })
        .catch((err) => {
          console.log('contract_info err', err);
          that.$message({
            type: 'error',
            message: err.msg || 'get contract_info err',
          });
        });
    },
		// 获取简单的订单信息
    get_simple_order() {
      let that = this;

      request({
        url: "/Api/other/get_simple_order",
        method: "POST",
        data: {
          company_id: that.company_id,
          order_id: that.order_id,
        },
      }).then((res) => {
				if (res.code != 0) {
					// 车行，联系运营经理
					// 客户，联系客服
					that.$message({
						type: "error",
						message: "获取订单详情失败，请联系客服",
					});
					that.$emit('error', {
						msg: '获取订单详情失败，请联系客服',
					});
					return;
				}
				that.order_info = res.data;
				const { pickup_time, dropoff_time, adjust_vehicle_id } = that.order_info;
				that.setInfoToContract({
					pickTime: formatDate(
						timeTransform(new Date(pickup_time * 1000)),
						"yyyy-M-dd hh:mm"
					),
					returnTime: formatDate(
						timeTransform(new Date(dropoff_time * 1000)),
						"yyyy-M-dd hh:mm"
					),
				});
				that.getDeposit();
				that.getGroupInfoById();
				that.getPickupReturnAddress();
				const isMobile = _isMobile() && !!_isMobile().length;
				if (adjust_vehicle_id) {
					that.get_vehicle_by_id();
				} else if (!isMobile) {
					that.setInfoToContract({
						cardNumber: '',
					});
				} else {
					console.log('租车通在入口做了处理，保证进来是有车辆的')
					// that.setInfoToContract({
					// 	cardNumber: ascription_contry + ascription_city + registration_number,
					// });
					// that.$alert(`当前订单还未分配车辆，请先分配车辆后再操作租赁合同签名`, '提示', {
					// 		confirmButtonText: '分配车辆',
					// 		customClass: 'alert_container',
					// 		type: 'warning',
					// 		showCancelButton: false,
					// 		showClose: false,
					// 		closeOnClickModal: false,
					// 		closeOnPressEscape: false,
					// 		callback: action => {
					// 				if (action === 'confirm') {
					// 						console.log('点击了confirm')
					// 						return;
					// 				}
					// 				console.log('未分配车辆 action', action);
					// 		}
					// });
				}
      });
    },
    // 获取客户详情
    get_customer_details_order() {
      let that = this;
      request({
        url: "/Api/other/get_customer_details_order",
        method: "POST",
        data: {
          company_id: that.company_id,
          order_id: that.order_id,
        },
      }).then((res) => {
				if (res.code == 0) {
					const { cust_passport_num, cust_phone } = res.data;
					that.setInfoToContract({
						idCard: cust_passport_num,
						number: cust_phone,
					});
				}
      });
    },
    // 通过车辆id获取车辆信息
    get_vehicle_by_id() {
      let that = this;
      request({
        url: "/Api/other/get_vehicle_by_id",
        method: "POST",
        data: {
          id: that.order_info.adjust_vehicle_id,
        },
      }).then((res) => {
        if (res.data && res.code == 0) {
					const { ascription_contry, ascription_city, registration_number } = res.data;
					that.setInfoToContract({
						cardNumber: ascription_contry + ascription_city + registration_number,
					});
        }
      });
    },

    // 通过车型组id获取车型组信息——车型组
    getGroupInfoById() {
      let that = this;
      request({
        url: "/Api/other/getGroupInfoById",
        method: "POST",
        data: {
          company_id: that.company_id,
          veh_group_id: that.order_info.adjust_veh_group_id,
        },
      }).then((res) => {
				if (res.code == 0) {
					const { group_name_cn } = res.data;
					that.setInfoToContract({
						cardGroup: group_name_cn,
					})
				}
      });
    },
    // 获取订单——取还车地址
    getPickupReturnAddress() {
      let that = this;
      request({
        url: "/Api/other/getPickupReturnAddress",
        method: "POST",
        data: {
          oid: that.order_info.id,
        },
      })
			.then((res) => {
        if (res.data && res.code == 0) {
					const { pickup_address, return_address } = res.data;
          that.address_info = res.data;
					that.setInfoToContract({
						pickAddress: pickup_address,
						returnAddress: return_address,
					});
        } else {
					const { dropoff_store_id, pickup_store_id } = that.order_info;
					if (pickup_store_id === dropoff_store_id) {
						that.get_branch_address(orderType.same, that.order_info.dropoff_store_id);
					} else {
						that.get_branch_address(
              orderType.pick,
              dropoff_store_id,
            );
            that.get_branch_address(
              orderType.return,
              that.order_info.pickup_store_id,
            );
					}
				}
      });
    },
		// 获取订单取还车地址失败后，获取门店地址
    get_branch_address(type, store_id) {
      let that = this;
      request({
        url: "/Api/other/get_branch_address",
        method: "POST",
        data: {
          store_id: store_id,
          company_id: that.company_id,
        },
      })
				.then((res) => {
					if (res.data && res.code == 0) {
						const { branch_address } = res.data;
						const params = {};
						if (type === '00') {
							params.pickAddress = branch_address;
							params.returnAddress = branch_address;
						} else if (type == "01") {
								params.pickAddress = branch_address;
						} else {
							params.returnAddress = branch_address;
						}
						that.setInfoToContract(params);
					}
				});
    },
    // 获取简单公司信息
    get_sim_company_info() {
      let that = this;

      request({
        url: "/Api/other/get_sim_company_info",
        method: "POST",
        data: {
          company_id: that.company_id,
        },
      }).then((res) => {
				console.log('get_sim_company_info', res)
				if (res.code == 0) {
        	that.company_info = res.data.info;
				}
      });
    },
		// 获取押金信息相关
		async getDeposit() {
			const that = this;
			const [r1, r2, r3] = await Promise.all([
				request({
					url: "/Api/other/getGroupBasePriceInfo",
					method: "POST",
					data: {
						company_id: that.company_id,
						store_id: that.order_info.pickup_store_id,
						veh_group_ids: [that.order_info.veh_group_id],
					},
				}),
				// 获取订单标签是否含免押
				request({
					url: "/Api/other/get_order_label_deposit",
					method: "POST",
					data: {
						oid: that.order_info.id,
						order_id: that.order_id,
						company_id: that.company_id,
					},
				}),
				// 收费记录
				request({
					url: "/Api/other/get_payment_order_goods",
					method: "POST",
					data: {
						company_id: that.company_id,
						order_id: that.order_id,
					},
				}),
			]);
			if (r1.code == 0 && r2.code == 0 && r3.code == 0) {
				const { deposit } = r2.data;
				let num = null;
				r3.data.forEach((item) => {
          if (item.goods_type_id == 28) {
            num = item.amount;
          }
        });
        const str = r3.data
					.filter(item => item.type == 'charge')
					.map(element => {
						const name = that.$t(element.name);
						const payment_type = that.$t(element.payment_type);
						return `${element.option_name == element.name ? name : payment_type + " " + element.option_name }: ${chargeStatusMap[element.status]}`;
					})
					.reduce((a, b) => {
						a += '<p class="ql-align-justify"><span style="font-size: 14px; line-height: 1.75;">' + b + '</span><p>';
						return a;
					}, '');
				const pattern = new RegExp('\{' + 'extractChargeList' + '\}', 'g');
				that.content = that.content.replace(pattern, str);
				that.setInfoToContract({
					illegalDeposit: deposit ? '信用免押' : `${r1.data[0].violation_deposit - 0}元（还车时收取)`,
					cardDeposit: deposit ? '信用免押' : `${num - 0} 元（线下收取）`,
				});
			}
		},
		// 获取双方签名情况
		getSignatureAll() {
			let that = this;
			const { order_id, company_id } = this.$route.query;

			return request({
				url: "/Api/contract/getSignatureAll",
				method: "POST",
				data: {
					order_id,
					company_id,
					isNeedFileUrl: true,
				}
			})
				.then(res => {
					if (res.code != 0) {
						that.$message({
							type: "error",
							message: res.msg || res.message
						});
						return null;
					}
					const { supplier, customer } = res.data;
					const params = {
						companyImage: supplier ? `<img src='${supplier.fileUrl}' style="width: 300px; height: 200px" alt>` : '<p><br><br><br></p>',
						userImage: customer ? `<img src='${customer.fileUrl}' style="width: 300px; height: 200px" alt>` : '<p><br><br><br></p>',
					};
					that.setInfoToContract(params)
					that.signAll = res.data;
					return true;
				})
				.catch(err => {
					that.$message({
						type: "error",
						message: err.msg || err.message
					});
				});
		},
		/**
		 * 更新内容到合同里的占位符
		 * @objct
		 * {key: val}
		 */
		async setInfoToContract(object) {
			formData = {
				...formData,
				...object,
			}
			const that = this;
			Object.keys(object).forEach(item => {
				if (that.basicObject[item]) {
					const pattern = new RegExp('\{' + that.basicObject[item] + '\}', 'g');
					that.content = that.content.replace(pattern, object[item]);
					delete this.basicObject[item];
				} else if (that.extraObject[item]) {
					console.log('命中 is_need_sign', that.extraObject[item]);
					const pattern = new RegExp('\{' + that.extraObject[item] + '\}', 'g');
					that.content = that.content.replace(pattern, object[item]);
					delete that.extraObject[item];
				}
			});
			// console.log('basicObject', JSON.stringify({
			// 	...that.extraObject,
			// 	...this.basicObject
			// }));
			//  基本信息已拿到
			if (!Object.keys(that.basicObject).length && (!that.is_need_sign || !Object.keys(this.basicObject).length)) {
				this.loading.close();
				let str = this.content;
				if (this.is_need_contract_image) {
					this.generate();
				} else {
					let pattern = new RegExp('\{' + isNeedSignMap.companyImage + '\}', 'g');
					str = str.replace(pattern, '<p><br><br><br></p>');
					pattern = new RegExp('\{' + isNeedSignMap.userImage + '\}', 'g');
					str = str.replace(pattern, '<p><br><br><br></p>');
				}
				this.$emit('templateData', str);
				this.$emit('formData', formData);
			}
		},
		isSetComplete() {
			return !Object.keys(this.basicObject).length && (!this.is_need_sign || !Object.keys(this.basicObject).length);
		}
	}
}
</script>

<style scoped>
.contract {
	position: absolute;
	top: 0;
	left: -200%;
	width: 100%;
}
.ql-container.ql-snow  {
	border: none;
}

</style>
<style>
.alert_container {
	width: 80%;
}
</style>